import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import About from "@/components/landing/About";
import CtaBanner from "@/components/landing/CtaBanner";
import Footer from "@/components/landing/Footer";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import WebApp from "@/web/WebApp";

const Landing = () => (
  <div data-testid="landing-page">
    <Nav />
    <main>
      <Hero />
      <Marquee />
      <About />
      <CtaBanner />
    </main>
  </div>
);

const SiteFooter = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/app")) return null;
  return <Footer />;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App min-h-screen overflow-x-clip bg-obsidian font-body text-slate-100 antialiased">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/app" replace />} />
          <Route path="/about" element={<Landing />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/app/*" element={<WebApp />} />
        </Routes>
        <SiteFooter />
      </BrowserRouter>
    </div>
  );
}

export default App;
